import { callToGetDealerAction, setStoreConfiguration, setStoreData, storeDataInitialValue } from "@/redux/app-slice";
import { put, takeEvery, call, select } from "redux-saga/effects";
import { automateTransferWorkflowApi } from "./fflSelectActions";
import { PayloadAction } from "@reduxjs/toolkit";
import { createUser, deleteUser, editUser, generateEncryption, getStoreTermsAndConditions, putDealerActionTimeout, putStoreTermsAndConditions, removeEncryptionKeyApi, updateStoreConfigurationApi, updateStoreFilterConfigApi, getAllPreferredDealers, getAllPreferredDealersByBackEnd, callCustomWebhookTestConnection, callCustomWebhookRotate, UpdateCustomWebhookConfiguration, GetCustomWebhookConfiguration } from "@/api/apis";
import { CreateUserInterface, EditUserInterface, StoreConfigForm, StoreFilterConfig } from "../types";
import { AxiosResponse, isAxiosError } from "axios";
import { setCreateUserEmailError, setIsCreatingUser, setIsDeletingUser, setIsEditUserDetailsSaved, setIsEncryptionKeyRemoved, setIsGneratingEncryptionKey, setIsRemovingEncryptionKey, setIsSavingEditUserDetails, setIsUpdatingDealerctionTimeout, setIsStoreFilterConfigChanged, setIsUpdatingFilterConfig, setIsUpdatingStoreConfiguration, setIsUpdatingStoreFilterConfig, setIsUserCreated, setIsUserDelete, setStoreFilterConfig, setisEncryptionKeyGenerated, setStoreTermsAndConditions, storeTermsAndConditionInitailValue, setIsTermsAndCondtionUpdated, setIsTermsAndCondtionChanged, setIsEditableTermsAndContionsEnabled, setIsLoadingPreferredDealersExcelGeneration, setIsExportPreferredDealersButtonDisabled, clearCustomWebhookTestResult, setCustomWebhookTestResult, setCustomWebhookError, setCustomWebhookData, setCustomWebhookIsLoadingSave, setCustomWebhookIsPostDataSave, setCustomWebhookIsLoadingRotate, setCustomWebhookIsLoadingTestConnection, setCustomWebhookRotateResult } from "./slice";
import fflSelectInterface from "@/model/ffl-select.mjs";
import { ToasterNotification } from "@/toaster/toasterNotification";
import { callToGetStoreFilterConfigData } from "@/queue/ducks/slice";
import { DealerActionTimeout } from "@/model/profile.mjs";
import { exportXLSXFile } from "../utils";
import { RootState } from '@/redux/store';
import { getCustomWebhookIsPostDataSave, getIsExportPreferredDealersButtonDisabled } from "./selectors";

function* updateAutomateTransferWorkflow() {
    try {
        //@ts-ignore
        const automatedTransferWorkflow = yield select((state: RootState) => state.store.is_pending_workflow)
        //@ts-ignore
        const response = yield call(automateTransferWorkflowApi, automatedTransferWorkflow);
        if (response?.status === 200) {
          yield put(setStoreData(response.data));
        }
      } catch (error) {
        console.log('error', error);
        yield put(setStoreData(storeDataInitialValue));
      }
}

function* createUserHandler(action: PayloadAction<CreateUserInterface>) {
  try {
      yield put(setIsCreatingUser(true));
      const response: AxiosResponse<CreateUserInterface> = yield call(createUser, action.payload);
      if (response?.status === 201) {
        yield put(setIsUserCreated(true));
      }
    } catch (error) {
      console.log('error', error);
      if (isAxiosError(error) && error.response && error.response?.status === 409 && error.response.data) {
        yield put(setCreateUserEmailError(error.response.data.Error))
      }
    } finally {
      yield put(setIsCreatingUser(false));
    }
}

function* deleteUserHandler(action: PayloadAction<string>) {
  try {
      yield put(setIsDeletingUser(true));
      const response: AxiosResponse<CreateUserInterface> = yield call(deleteUser, action.payload);
      if (response?.status === 200) {
        yield put(setIsUserDelete(true));
      }
    } catch (error) {
      console.log('error', error);
    } finally {
      yield put(setIsDeletingUser(false));
    }
}

function* editUserHandler(action: PayloadAction<{data: EditUserInterface, userId: string}>) {
  try {
      yield put(setIsSavingEditUserDetails(true));
      const response: AxiosResponse<CreateUserInterface> = yield call(editUser, action.payload.data, action.payload.userId);
      if (response?.status === 200) {
        yield put(setIsEditUserDetailsSaved(true));
      }
    } catch (error) {
      console.log('error', error);
    } finally {
      yield put(setIsSavingEditUserDetails(false));
    }
}

function* generateEncryptionKey() {
  try {
      yield put(setIsGneratingEncryptionKey(true));
      const response: AxiosResponse<fflSelectInterface> = yield call(generateEncryption);
      if (response?.status === 200) {
        yield put(setisEncryptionKeyGenerated(true));
        yield put(setStoreConfiguration(response.data));
      }
    } catch (error) {
      console.log('error', error);
    } finally {
      yield put(setIsGneratingEncryptionKey(false));
    }
}

function* removeEncryptionKey() {
  try {
      yield put(setIsRemovingEncryptionKey(true));
      const response: AxiosResponse<fflSelectInterface> = yield call(removeEncryptionKeyApi);
      if (response?.status === 200) {
        yield put(setIsEncryptionKeyRemoved(true));
        yield put(setStoreConfiguration(response.data));
      }
    } catch (error) {
      console.log('error', error);
    } finally {
      yield put(setIsRemovingEncryptionKey(false));
    }
}


function* updateStoreConfiguration(action: PayloadAction<StoreConfigForm>) {
  try {
      yield put(setIsUpdatingStoreConfiguration(true));
      const response: AxiosResponse<fflSelectInterface> = yield call(updateStoreConfigurationApi, action.payload);
      if (response?.status === 200) {
        yield put(setIsEncryptionKeyRemoved(true));
        yield put(setStoreConfiguration(response.data));
        ToasterNotification('success', "Configuration updated successfully")
      }
    } catch (error) {
      console.log('error', error);
      ToasterNotification('error', "Configuration updated failed")
    } finally {
      yield put(setIsUpdatingStoreConfiguration(false));
    }
}

function* updateDealerActionTimeout(action: PayloadAction<DealerActionTimeout>) {
  try {
      yield put(setIsUpdatingDealerctionTimeout(true));
      const response: AxiosResponse<DealerActionTimeout> = yield call(putDealerActionTimeout, action.payload);
      if (response?.status === 200) {
        yield put(callToGetDealerAction());
        ToasterNotification('success', "Dealer action timeout updated successfully")
      }
    } catch (error) {
      console.log('error', error);
      ToasterNotification('error', "Dealer action timeout updated failed")
    } finally {
      yield put(setIsUpdatingDealerctionTimeout(false));
    }
  }
function* updateStoreFilterConfig(action: PayloadAction<StoreFilterConfig>) {
  try {
      yield put(setIsUpdatingStoreFilterConfig(true));
      const response: AxiosResponse<StoreFilterConfig> = yield call(updateStoreFilterConfigApi, action.payload);
      if (response?.status === 200) {
        yield put(setStoreFilterConfig(response.data));
        ToasterNotification('success', "Filter configuration updated successfully")
        yield put(callToGetStoreFilterConfigData({}))
        yield put(setIsStoreFilterConfigChanged(false));
        
      }
    } catch (error) {
      console.log('error', error);
      ToasterNotification('error', "Failed to update the filter configuration!")
    } finally {
      yield put(setIsUpdatingStoreFilterConfig(false));
      yield put(setIsUpdatingFilterConfig(false))
    }
}

function* callCustomWebhookTestConnectionFunction(action:  PayloadAction<{ webhookUrl: string }>) {
  try {
    yield put(setCustomWebhookIsLoadingTestConnection(true));
    //@ts-ignore
    const response = yield call(callCustomWebhookTestConnection, action.payload);
    console.log("Respone Test Connection: ", JSON.stringify(response))
    if (response?.status === 200) {
        yield put(setCustomWebhookTestResult({
        success: response?.data?.success,
        message: response?.data?.message || 'Connection test successful',
        status: response?.data?.status
      }));
    }
  } catch (error: any) {
    console.log('Test connection error', error);
    const errorMessage = error.response?.data?.message || 'Connection test failed';
    yield put(setCustomWebhookError(errorMessage));
    yield put(setCustomWebhookTestResult({
      success: false,
      message: errorMessage
    }));
  } finally {
    yield put(setCustomWebhookIsLoadingTestConnection(false));
  }
}

function* callCustomWebhookRotateFunction(action:  PayloadAction<{ webhookUrl: string }>) {
  try {
    console.log("I am here", action.payload)
    yield put(setCustomWebhookIsLoadingRotate(true))
    //@ts-ignore
    const response = yield call(callCustomWebhookRotate, action.payload);
    console.log("Respone Test Connection: ", JSON.stringify(response))
    if (response?.status === 200) {
      console.log("Recieved the response",response)
      const webhookData = {
        id: response?.data?.record?.id,
        url: response?.data?.record?.url,
        secret: response?.data?.record?.secret,
        is_enabled: response?.data?.record?.is_enabled
      }
      yield put(setCustomWebhookData(webhookData));
      yield put(setCustomWebhookRotateResult({success: true}))
      yield put(setCustomWebhookIsLoadingRotate(false))
    }
  } catch (error: any) {
    yield put(setCustomWebhookIsLoadingRotate(false))
    console.log('error', error);
    yield put(setCustomWebhookError(error.message)); // ✅
  }
}

function* UpdateCustomWebhookConfigurationFunction(action:  PayloadAction<{ url: string, secret: string }>) {
  try {
    yield put(setCustomWebhookIsLoadingSave(true))
    //@ts-ignore
    const response = yield call(UpdateCustomWebhookConfiguration, action.payload);
    console.log("Respone Test Connection: ", JSON.stringify(response))
    if (response?.status === 201) {
      console.log("Status 204 maja aa gaya", response?.data)
      const webhookData = {
        id: response?.data?.id,
        url: response?.data?.url,
        secret: response?.data?.secret,
        is_enabled: response?.data?.is_enabled
      }
      yield put(setCustomWebhookData(webhookData));
      yield put(setCustomWebhookIsPostDataSave(true));
      yield put(setCustomWebhookIsLoadingSave(false))
    }
  } catch (error) {
    console.log('error', error);
    yield put(setCustomWebhookIsLoadingSave(false))
  }
}

function* GetCustomWebhookConfigurationFunction() {
  try {
    //@ts-ignore
    const response = yield call(GetCustomWebhookConfiguration);
    console.log("Respone Test Connection: ", JSON.stringify(response))
    console.log(response.status)
    if (response?.status === 200) {
      const webhookData = {
        id: response?.data?.id,
        url: response?.data?.url,
        secret: response?.data?.secret,
        is_enabled: response?.data?.is_enabled
      }
      yield put(setCustomWebhookData(webhookData));
    }
  } catch (error) {
    console.log('error', error);
  }
}


function* getStoreTermsAndConditionsSagaFunction() {
  try {
    //@ts-ignore
    const response = yield call(getStoreTermsAndConditions);
    if (response?.status === 200) {
      yield put(setStoreTermsAndConditions(response.data));
    }
  } catch (error) {
    console.log('error', error);
    yield put(setStoreTermsAndConditions(storeTermsAndConditionInitailValue));
  }
}

function* updateStoreTermsAndConditionsSagaFunction() {
  try {
    //@ts-ignore
    const updatedTermsAndConditions = yield select((state: RootState) => state.store.updatedStoreTermsAndConditions)
    //@ts-ignore
    const response = yield call(putStoreTermsAndConditions, updatedTermsAndConditions);
    if (response?.status === 204) {
      yield put(setStoreTermsAndConditions(updatedTermsAndConditions));
      yield put(setIsEditableTermsAndContionsEnabled(false))
      ToasterNotification('success', "Terms & conditions updated successfully")
    }
  } catch (error) {
    console.log('error', error);
    ToasterNotification('error', "Failed to update the terms & conditions!")
    //@ts-ignore
    const getTermsAndConditions = yield select((state: RootState) => state.store.storeTermsAndConditions)
    yield put(setStoreTermsAndConditions(getTermsAndConditions));
  }finally{
    //@ts-ignore
    yield put(setIsTermsAndCondtionUpdated(false))
    yield put(setIsTermsAndCondtionChanged(false))
  }
}

function* downloadPreferredDealersListExcel() {
  try {
    
    //@ts-ignore
    const needToCallPreferredDealersAPI = yield select((state: RootState) => state.store.needToCallPreferredDealersAPI);
    //@ts-ignore
    const metaData = yield select((state: RootState) => state.store.preferredDealersMetaData);
    //@ts-ignore
    const storeId = yield select((state: RootState) => state.app.storeId);

    
    
    yield put(setIsLoadingPreferredDealersExcelGeneration(true));
    yield put(setIsExportPreferredDealersButtonDisabled(true));
    
    console.log("needToCallPreferredDealersAPI : ", needToCallPreferredDealersAPI);
    console.log("Store ID : ", storeId);
    if(needToCallPreferredDealersAPI){
      //@ts-ignore
      const resp = yield call(getAllPreferredDealersByBackEnd, storeId);
      console.log("PRE : ", resp);
      ToasterNotification("success", "We are exporting your preferred dealers report. This will take a few minutes to complete, kindly check your email after 5-10 minutes.");
    } else {
      const totalRecords = metaData?.totalRecords || 0;
      const maxSize = 1000;
      let pageNumber = 0;
      let response = [];

      if (totalRecords > 10000) {
        let remainingRecords = totalRecords;

        while (remainingRecords > 0) {
          const pageSize = Math.min(maxSize, remainingRecords);
          const meta_data = { ...metaData, totalRecords: pageSize, pageNumber: ++pageNumber };

          //@ts-ignore
          const resp = yield call(getAllPreferredDealers, meta_data);
          response.push(...(resp?.data.data || []));
          remainingRecords -= pageSize;
        }
      } else {
        //@ts-ignore
        const resp = yield call(getAllPreferredDealers, metaData);
        response.push(...(resp?.data.data || []));
      }

      //@ts-ignore
      const generatedBy = yield select((rootState: RootState) => rootState.app.userName);
      exportXLSXFile(response, generatedBy);
    }
  } catch (error) {
    console.log('error', error);
    ToasterNotification('error', "Failed to retrieve preferred dealers!")
  } finally {
    yield put(setIsLoadingPreferredDealersExcelGeneration(false));
    yield put(setIsExportPreferredDealersButtonDisabled(false));
  }
}

function* watchCallToUpdateAutomateTransferWorkflow() {
    yield takeEvery("StoreAdminSlice/callToUpdateAutomateTransferWorkflow", updateAutomateTransferWorkflow);
}

function* watchCallToCreateUser() {
  yield takeEvery("StoreAdminSlice/callToCreateUser", createUserHandler);
}

function* watchCallToDeleteUser() {
  yield takeEvery("StoreAdminSlice/callToDeleteUser", deleteUserHandler);
}

function* watchCallToEditUser() {
  yield takeEvery("StoreAdminSlice/callToEditUser", editUserHandler);
}

function* watchCallToGenerateEncryptionKey() {
  yield takeEvery("StoreAdminSlice/callToGenerateEncryptionKey", generateEncryptionKey);
}

function* watchTocallToRemoveEncryptionKey() {
  yield takeEvery("StoreAdminSlice/callToRemoveEncryptionKey", removeEncryptionKey);
}

function* watchToCallToUpdateStoreConfiguration() {
  yield takeEvery("StoreAdminSlice/callToUpdateStoreConfiguration", updateStoreConfiguration);
}

function* watchToCallToUpdateDealerActionTimeout() {
  yield takeEvery("StoreAdminSlice/callToUpdateDealerActionTimeout", updateDealerActionTimeout);
}

function* watchToCallToUpdateStoreFilterConfig() {
  yield takeEvery("StoreAdminSlice/callToUpdateStoreFilterConfig", updateStoreFilterConfig);
}

function* watchCallToGetStoreTermsAndConditions() {
  yield takeEvery('StoreAdminSlice/callToGetStoreTermsAndConditions', getStoreTermsAndConditionsSagaFunction);
}

function* watchcallCustomWebhookTestConnection() {
  yield takeEvery('StoreAdminSlice/callToGetCustomWebhookTestConnectionResponse', callCustomWebhookTestConnectionFunction)
}

function* watchcallCustomWebhookRotate() {
  yield takeEvery('StoreAdminSlice/callToGetCustomWebhookRotateResponse', callCustomWebhookRotateFunction)
}

function* watchUpdateCustomWebhookConfiguration() {
  yield takeEvery('StoreAdminSlice/callToUpdateCustomWebhookConfiguration', UpdateCustomWebhookConfigurationFunction)
}

function* watchGetCustomWebhookConfiguration() {
  yield takeEvery('StoreAdminSlice/callToGetCustomWebhookConfigurationResponse', GetCustomWebhookConfigurationFunction)
}

function* watchToCallToUpdateStoreTermsAndConditions() {
  yield takeEvery("StoreAdminSlice/callToUpdateStoreTermsAndConditions", updateStoreTermsAndConditionsSagaFunction);
}

function* watchcallToDownloadPreferredDealersList() {
  yield takeEvery('StoreAdminSlice/downloadPreferredDealersListForExcel', downloadPreferredDealersListExcel);
}
export { watchCallToUpdateAutomateTransferWorkflow, watchCallToCreateUser, watchCallToDeleteUser, watchCallToEditUser, watchCallToGenerateEncryptionKey, watchTocallToRemoveEncryptionKey, watchToCallToUpdateStoreConfiguration, watchToCallToUpdateDealerActionTimeout, watchToCallToUpdateStoreFilterConfig, watchCallToGetStoreTermsAndConditions, watchToCallToUpdateStoreTermsAndConditions, watchcallToDownloadPreferredDealersList, watchcallCustomWebhookTestConnection, watchcallCustomWebhookRotate, watchUpdateCustomWebhookConfiguration, watchGetCustomWebhookConfiguration }
